import styles from '../Product.module.scss';
export interface ProductComparisonGridProps {
  children: React.ReactNode;
  classname?: string
}

export const ProductComparisonGrid = ({
  children,
  classname
}: ProductComparisonGridProps) => {
  return <div className={`${styles['product-comparison-grid']} ${classname}`}>{children}</div>;
};
